import React from 'react';
const DiamondYellowSvg = ({ id }) => {
    const linear1 = `linear_DY_1_${id}`;
    const linear2 = `linear_DY_2_${id}`;
    const linear3 = `linear_DY_3_${id}`;
    const linear4 = `linear_DY_4_${id}`;
    const linear5 = `linear_DY_5_${id}`;
    const linear6 = `linear_DY_6_${id}`;
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M22 8H17L12 23L22 8Z", fill: `url(#${linear1})` }),
        React.createElement("path", { d: "M2 8H7L8 3L2 8Z", fill: `url(#${linear2})` }),
        React.createElement("path", { d: "M22 8H17L16 3L22 8Z", fill: `url(#${linear3})` }),
        React.createElement("path", { d: "M2 8H7L12 23L2 8Z", fill: `url(#${linear4})` }),
        React.createElement("path", { d: "M7 8H17L12 23L7 8Z", fill: `url(#${linear5})` }),
        React.createElement("path", { d: "M8 3H16L17 8H7L8 3Z", fill: `url(#${linear6})` }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: linear1, x1: "14.7778", y1: "8.68182", x2: "24.7803", y2: "19.3962", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E89029" }),
                React.createElement("stop", { offset: "1", stopColor: "#E6D84F" })),
            React.createElement("linearGradient", { id: linear2, x1: "8", y1: "8", x2: "6.44918", y2: "4.96728", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E5E053" }),
                React.createElement("stop", { offset: "1", stopColor: "#E89028" })),
            React.createElement("linearGradient", { id: linear3, x1: "16", y1: "6.40909", x2: "21.5726", y2: "5.56267", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#F7E090" }),
                React.createElement("stop", { offset: "1", stopColor: "#F7E747" })),
            React.createElement("linearGradient", { id: linear4, x1: "4.22222", y1: "12.375", x2: "15.5272", y2: "10.3125", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E89029" }),
                React.createElement("stop", { offset: "1", stopColor: "#E6DA50" })),
            React.createElement("linearGradient", { id: linear5, x1: "9.22222", y1: "12.375", x2: "20.5272", y2: "10.3125", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#E89029" }),
                React.createElement("stop", { offset: "1", stopColor: "#E6DA50" })),
            React.createElement("linearGradient", { id: linear6, x1: "6.5", y1: "8", x2: "8.4387", y2: "0.822558", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#EDE643" }),
                React.createElement("stop", { offset: "1", stopColor: "#E89028" })))));
};
export { DiamondYellowSvg };
//# sourceMappingURL=DiamondYellowSvg.js.map